import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import styles from './index.module.less';
export const Field = ({ required, name, hint, tip, className, children, ...rest }) => {
    return (_jsxs("div", { className: classnames(styles.field, className, {
            [styles.required]: required,
        }), ...rest, children: [_jsxs("div", { className: styles.header, children: [name && _jsx("label", { className: styles.fieldName, children: name }), hint ? hint : null, tip && _jsx("span", { className: styles.tip, children: tip })] }), _jsx("div", { className: styles.content, children: children })] }));
};
